import { Component, NgZone } from '@angular/core';
import { OrderButtonComponent } from '../order-button/order-button.component';
import { ModalService } from '@proximus/ng-common-components';
import { Store } from '@ngrx/store';
import { ApplicationState } from '../../store/reducers';
import { AnalyticsService, TranslationService } from '@proximus/ng-common';
import { OptionLockService } from '../../services/option-lock.service';
import { OptionConfigurationLockService } from '../../services/option-configuration-lock.service';

@Component({
  selector: 'mprd-order-switch',
  templateUrl: './order-switch.component.html',
  styleUrls: ['./order-switch.component.css'],
})
export class OrderSwitchComponent extends OrderButtonComponent {
  constructor(
    modalService: ModalService,
    store: Store<ApplicationState>,
    ngZone: NgZone,
    analyticsService: AnalyticsService,
    optionLockService: OptionLockService,
    optionConfigurationLockService: OptionConfigurationLockService,
    translationService: TranslationService,
  ) {
    super(
      modalService,
      store,
      ngZone,
      analyticsService,
      optionLockService,
      optionConfigurationLockService,
      translationService,
    );
  }
}
